import type { Activity } from 'types/activity';

export const getActivityColor = (activity: Activity): string => {
  if (!activity.project) return activity.client.color;
  if (activity.project.color) return activity.project.color;
  return activity.project.client.color;
};
